import { tryCatch } from "@/lib/try-catch";
import { Ok, Err } from "ts-results";
import { API_BASE_URL } from "@/lib/constants";
import { Response } from "./types";

export interface ShareReportRequest {
  reportId: string;
  email: string;
}

export async function shareReport(
  shareReportRequest: ShareReportRequest
): Promise<Response<string>> {
  const responseResult = await tryCatch(
    fetch(`${API_BASE_URL}/api/v1/reportes/${shareReportRequest.reportId}/compartidos`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: shareReportRequest.email }),
    })
  );

  if (responseResult.err) {
    return Err({
      message: `Error al consultar el servidor: ${responseResult.val.message}`,
      devMessage: responseResult.val.message,
    });
  }

  const response = responseResult.val;

  if (!response.ok) {
    const errorMessageResult = await tryCatch(response.json());
    return errorMessageResult.err
      ? Err({
          message: `Error al compartir el reporte: ${errorMessageResult.val.message}`,
          devMessage: errorMessageResult.val.message,
        })
      : Err({
          message: errorMessageResult.val.message,
          devMessage: errorMessageResult.val.devMessage,
        });
  }

  const dataResult = await tryCatch(response.text());

  if (dataResult.err) {
    return Err({
      message: `Error al leer la respuesta del servidor: ${dataResult.val.message}`,
      devMessage: dataResult.val.message,
    });
  }

  return Ok(dataResult.val);
}

export interface RevokeSharedReportRequest {
  reportId: string;
  sharedReportId: string;
}

export async function revokeSharedReport(
  request: RevokeSharedReportRequest
): Promise<Response<string>> {
  const responseResult = await tryCatch(
    fetch(`${API_BASE_URL}/api/v1/reportes/${request.reportId}/compartidos/${request.sharedReportId}`, {
      method: "DELETE",
      credentials: "include",
    })
  );

  if (responseResult.err) {
    return Err({
      message: `Error al consultar el servidor: ${responseResult.val.message}`,
      devMessage: responseResult.val.message,
    });
  }

  const response = responseResult.val;

  if (!response.ok) {
    const errorMessageResult = await tryCatch(response.json());
    return errorMessageResult.err
      ? Err({
          message: `Error al desvincular el reporte: ${errorMessageResult.val.message}`,
          devMessage: errorMessageResult.val.message,
        })
      : Err({
          message: errorMessageResult.val.message,
          devMessage: errorMessageResult.val.devMessage,
        });
  }

  const dataResult = await tryCatch(response.text());

  if (dataResult.err) {
    return Err({
      message: `Error al leer la respuesta del servidor: ${dataResult.val.message}`,
      devMessage: dataResult.val.message,
    });
  }

  return Ok(dataResult.val);
}